export default __webpack_public_path__ + "static/media/antelope-8-thumbnail.3ffa1dd7.webp";